let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ME74m")).then(() => parcelRequire('4vFQJ'));